// import store, { modulesName } from '@/store'

// export const authHandler = (config) => {
//   if (store.getters[`${modulesName.userModuleName}/authenticated`]) {
//     console.log(store.getters[`${modulesName.userModuleName}/tokenType`]);
//     console.log(store.getters[`${modulesName.userModuleName}/accessToken`]);
//     config.headers.Authorization = `${
//       store.getters[`${modulesName.userModuleName}/tokenType`]
//     } ${store.getters[`${modulesName.userModuleName}/accessToken`]}`
//   } else {
//     config.headers.Authorization = undefined
//   }
// }
import { getUser } from '@/core/auth';
export const authHandler = async (config) => {
  // TODO: Implementacion correcta usando el SessionManger (Periodo de prueba)
  let user = await getUser();
  if (user != undefined) {
    config.headers.Authorization = `${user.token_type} ${user.access_token}`;
  } else {
    config.headers.Authorization = undefined;
  }
};
